import Reveal, { SectionLabel } from "@/components/Reveal";
import { Handshake, LifeBuoy, Gift, Send } from "lucide-react";

const POINTS = [
  {
    icon: LifeBuoy,
    title: "Guided Setup",
    desc: "If you choose the partnered broker, the founder personally helps you through the account setup process.",
  },
  {
    icon: Gift,
    title: "Available Benefits",
    desc: "Any promotions or account benefits applicable to your account, explained and applied where possible.",
  },
  {
    icon: Handshake,
    title: "Zero Obligation",
    desc: "Happy with your current broker? Stay with them and use Atlas exactly the same. Nothing changes.",
  },
];

const BrokerPerk = () => (
  <section id="broker" className="relative py-20 lg:py-28" data-testid="broker-section">
    <div className="max-w-5xl mx-auto px-5 sm:px-8">
      <Reveal>
        <div className="relative border border-dashed border-line rounded-md bg-panel/30 px-7 py-10 sm:px-12 sm:py-12" data-testid="broker-card">
          <span className="absolute -top-3 left-7 sm:left-12 bg-ink px-3 font-mono text-[10px] tracking-[0.3em] text-slate-500 uppercase" data-testid="broker-label">
            Optional Member Benefit · Not Part of Atlas
          </span>

          <div className="grid lg:grid-cols-12 gap-8 lg:gap-12 items-start">
            <div className="lg:col-span-5">
              <SectionLabel>Partnered Broker</SectionLabel>
              <h2 className="mt-4 font-display font-extrabold tracking-tight text-2xl sm:text-3xl text-slate-50 leading-tight" data-testid="broker-title">
                A partnered broker.
                <span className="text-gold-gradient"> If you want one.</span>
              </h2>
              <p className="mt-5 text-sm sm:text-base text-slate-400 leading-relaxed">
                Atlas itself is the indicator, the education, the analysis and the community — and it works with
                any broker, always. Separately, members have the option of a partnered broker, which can make
                setup and support easier. It's an optional benefit of being part of Atlas, never a requirement
                to purchase or use the indicator.
              </p>
              <a
                href="https://t.me/addlist/O9NU4HFXS-cxYzNk"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="broker-telegram-link"
                className="mt-7 inline-flex items-center gap-2.5 border border-slate-600 text-slate-300 font-medium text-sm px-6 py-3 rounded-sm hover:border-gold hover:text-gold transition-colors duration-300"
              >
                <Send size={14} />
                Ask About the Partnered Broker
              </a>
            </div>

            <div className="lg:col-span-7 space-y-5">
              {POINTS.map((p, i) => (
                <div key={p.title} className="flex gap-4 items-start" data-testid={`broker-point-${i + 1}`}>
                  <span className="mt-0.5 w-9 h-9 shrink-0 rounded-sm border border-line bg-card2/60 flex items-center justify-center">
                    <p.icon size={15} className="text-gold/80" />
                  </span>
                  <div>
                    <h3 className="font-display font-bold text-sm sm:text-base text-slate-100">{p.title}</h3>
                    <p className="mt-1 text-sm text-slate-400 leading-relaxed">{p.desc}</p>
                  </div>
                </div>
              ))}
              <p className="pt-2 text-[11px] text-slate-600 leading-relaxed border-t border-line/60" data-testid="broker-note">
                Completely optional. Atlas never requires a specific broker, and choosing not to use the partnered
                broker affects nothing about your access, analysis or community.
              </p>
            </div>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);

export default BrokerPerk;
